export default "__VITE_ASSET__CG0g6dtz__"